import { jwtDecode } from "jwt-decode";
// Variable para almacenar los datos del usuario
let user = null;
let userPermissions = [];
// Función para decodificar el token y almacenar los datos
export function setUserFromToken(token) {
    try {
        const decoded = jwtDecode(token);
        user = decoded;
        // Normalizar permisos a array de strings
        if (decoded.permisos) {
            userPermissions = Array.isArray(decoded.permisos)
                ? decoded.permisos
                : [decoded.permisos];
        }
        else {
            userPermissions = [];
        }
    }
    catch (error) {
        console.error("Error al decodificar el token:", error);
        clearUser(); // Limpia el store si el token es inválido
    }
}
// Función para obtener los datos del usuario
export function getUser() {
    return user;
}
// Función para limpiar los datos del usuario al cerrar sesión
export function clearUser() {
    user = null;
    userPermissions = [];
}
// Función para obtener los permisos del usuario
export function getPermissions() {
    return userPermissions;
}
// Función para verificar si el usuario tiene un permiso específico
export function hasPermission(code) {
    // Si es admin total (isAdmin claim == 'True'), tiene todos los permisos
    const isAdmin = user?.isAdmin?.toString().toLowerCase();
    if (isAdmin === "true")
        return true;
    return userPermissions.includes(code);
}
